import React from 'react';
import { TableHead } from '@redpanda/ui';

interface BulkSelectHeaderProps {
  allSelected: boolean;
  onToggleAll: () => void;
  hasItems: boolean;
}

const BulkSelectHeader: React.FC<BulkSelectHeaderProps> = ({
  allSelected,
  onToggleAll,
  hasItems
}) => {
  return (
    <TableHead className="relative" style={{ width: '60px', paddingLeft: '24px', paddingRight: '12px' }}>
      <div className="flex items-center justify-center">
        <input
          type="checkbox"
          checked={hasItems && allSelected}
          onChange={onToggleAll}
          className="h-4 w-4 rounded border-slate-300 text-brand-600 focus:ring-brand-500"
          style={{ position: 'absolute', left: '40px' }}
        />
      </div>
    </TableHead>
  );
};

export default BulkSelectHeader;
